import React from "react";
import { Trash2 } from "lucide-react";

/** Ad account name, id and campaign count on top of its rotation card. */
const CampaignAccountHeader = ({ account, count, onRemove }) => {
  return (
    <div className="flex items-center justify-between gap-3 rounded-t-xl border-b border-gray-100 bg-gray-50/70 px-4 py-2.5">
      <div className="flex min-w-0 flex-wrap items-baseline gap-x-2">
        <p className="truncate text-sm font-semibold text-gray-900">
          {account.ad_account_name || account.meta_ad_account_id}
        </p>
        <p className="font-mono text-[11px] text-gray-400">
          {account.meta_ad_account_id}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <span className="text-xs text-gray-500">
          {count} {count === 1 ? "campaign" : "campaigns"}
        </span>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="rounded-md p-1.5 text-gray-400 hover:bg-rose-50 hover:text-rose-600"
            aria-label="Remove account"
            title="Remove account"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default CampaignAccountHeader;
